import { useAuth0 } from '@auth0/auth0-react';
import { hasPermission } from '@/utils/userAccess';
import { Permissions } from '@/types';

export function useHavePermission(permission: Permissions): boolean {
  const { user } = useAuth0();
  return hasPermission(permission, user);
}
